var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightGrayArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 52,
    viewBox: "0 0 27 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0311 26.0002L0.801137 4.18276C0.626347 4.00693 0.488162 3.79819 0.394576 3.56862C0.300991 3.33904 0.253865 3.09318 0.255924 2.84526C0.257984 2.59735 0.309187 2.35231 0.406574 2.12431C0.50396 1.89632 0.645597 1.68991 0.823284 1.51701C1.00097 1.34412 1.21118 1.20818 1.44175 1.11706C1.67232 1.02595 1.91867 0.98146 2.16655 0.98618C2.41443 0.990899 2.65891 1.04473 2.88584 1.14456C3.11278 1.24438 3.31766 1.38823 3.48864 1.56776L25.9886 24.6928C26.3292 25.0428 26.5197 25.5119 26.5197 26.0002C26.5197 26.4886 26.3292 26.9577 25.9886 27.3077L3.48864 50.4327C3.31766 50.6123 3.11278 50.7561 2.88584 50.8559C2.65891 50.9558 2.41443 51.0096 2.16655 51.0143C1.91867 51.019 1.67232 50.9746 1.44175 50.8834C1.21118 50.7923 1.00097 50.6564 0.823284 50.4835C0.645597 50.3106 0.50396 50.1042 0.406574 49.8762C0.309187 49.6482 0.257984 49.4032 0.255924 49.1552C0.253865 48.9073 0.300991 48.6615 0.394576 48.4319C0.488162 48.2023 0.626347 47.9936 0.801137 47.8177L22.0311 26.0002Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGrayArrow);
export default __webpack_public_path__ + "static/media/right_gray_arrow.0249da20d4f766634311bc7cce012247.svg";
export { ForwardRef as ReactComponent };